import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import AepsInvoice from "./aepsInvoice";
import "./invoicePage.css";

function AepsInvoicePage() {
  const { transactionId } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  const handleBack = () => {
    history.goBack();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 200);
    return () => clearTimeout(timer);
  }, [transactionId]);

  return (
    <div className="invoice-page-layout compact">
      <div className="invoice-page-content compact">
        {loading ? (
          <div className="compact-loading">
            <div className="compact-spinner">
              <div className="spinner-circle"></div>
            </div>
            <p>Loading AEPS receipt...</p>
          </div>
        ) : (
          <div className="invoice-container-compact">
            <AepsInvoice
              transactionId={transactionId}
              isPageView={true}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default AepsInvoicePage;
